import { tns } from 'tiny-slider/src/tiny-slider'

/**
 * Photo Testimonials Block
 * @see https://github.com/ganlanyuan/tiny-slider
 */
const photoTestimonialBlocks = document.querySelectorAll('.block--photo-testimonial')
if (photoTestimonialBlocks.length) {
  const slider = tns({
    container: '.block--photo-testimonial .slides',
    items: 1,
    // mode: 'gallery',
    slideBy: 'page',
    autoplay: true,
    autoplayButtonOutput: false,
    controls: false,
    nav: true,
  })
}
